import { useEffect, useState } from 'react'

import logo from '../../../images/png/logo.png'

import Ethos_Myyja from '../../../images/svg/Ethos_Myyja.svg'
import Pathos_Myyja from '../../../images/svg/Pathos_Myyja.svg'
import Logos_Myyja from '../../../images/svg/Logos_Myyja.svg'


import './Instructions.css'

const Instructions = ({nextPage, setAllowScroll}) => {

    useEffect(() => {
        const button = isInViewport(document.getElementById('last-element'))
        if (!button) {
            setAllowScroll(true)
        }
    }, [])
    
    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    return(
        <div className='instructions-container'>
            <img className='instructions-logo' alt='' src={logo} />
            <button id='continue-after-intro-button' onClick={() => nextPage()}>Aloita peli</button>
            <div className='instructions-text'>
            Mukavalla asialla on kuunnelma puhelinmyynnistä. Voit 
            valita, toimitko asiakkaan vai myyjän roolissa Aristoteleen oppien mukaan.
            Lopussa sattuma vaikuttaa siihen, kumman retoriikka voittaa!

            </div>
            
            <div className='instructions-button-container'>
                <div className='instructions-button-row'>
                    <img className='instruction-logos' alt='' src={Ethos_Myyja} />
                    <div className='instructions-button-explainer'>
                        Ethos: vakuutat olemalla luotettava
                    </div>
                </div>

                <div className='instructions-button-row'>
                    <img className='instruction-logos' alt='' src={Pathos_Myyja} />
                    <div className='instructions-button-explainer'>
                        Pathos: vetoa tunteisiin
                    </div>
                </div>

                <div className='instructions-button-row'>
                    <img id='last-element' className='instruction-logos' alt='' src={Logos_Myyja} />
                    <div className='instructions-button-explainer'>
                        Logos: vaikuta järkipuheen avulla
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Instructions